import { LeafModal } from "./modal.component.js";
customElements.define("leaf-modal", LeafModal);
export {
  LeafModal
};
//# sourceMappingURL=modal.js.map
